import React, { useMemo, useState } from "react";
import { useLang } from "@/i18n/LanguageContext";
import { Section, SectionHead, Chips, RarityDot } from "@/components/landing/Section";
import TrollMap from "@/components/landing/TrollMap";
import { FILTERS, RARITY_COLORS, TROLLS } from "@/lib/trolls";

const KEYS = ["all", "common", "rare", "epic", "legendary", "festivals", "merchants"];

export default function MapSection() {
  const { t } = useLang();
  const [filter, setFilter] = useState("all");
  const visible = useMemo(() => TROLLS.filter(FILTERS[filter]), [filter]);
  const counts = useMemo(() => Object.fromEntries(KEYS.map((k) => [k, TROLLS.filter(FILTERS[k]).length])), []);

  return (
    <Section id="map" testId="map-section">
      <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
        <SectionHead kicker={t.map.kicker} title={t.map.title} body={t.map.body} />
        <div className="flex flex-wrap gap-x-5 gap-y-2 text-xs font-bold text-ink-muted" data-testid="map-legend">
          {Object.entries(RARITY_COLORS).map(([k, c]) => (
            <span key={k} className="inline-flex items-center gap-2"><RarityDot color={c} /> {t.rarity[k]}</span>
          ))}
        </div>
      </div>
      <div className="mt-10 mb-5 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <Chips options={KEYS.map((k) => [k, t.map.chips[k]])} value={filter} onChange={setFilter} prefix="map-filter" counts={counts} />
        <span data-testid="map-visible-count" className="text-sm font-bold text-ink-muted tabular-nums">
          {visible.length} {t.map.showing}
        </span>
      </div>
      <TrollMap trolls={visible} />
    </Section>
  );
}
